<template>
    <div id="infinite-list" class="main-wrapper scroll-y custom-scrollbar with-tabs view-news">

        <page-title :title="'Piwa marki '+ this.$route.params.slug" :back="true"></page-title>

        <div v-for="(item,index) in beers" :key="item.slug">
            <item-brand-beer
                    :index="index+1"
                    :slug="item.slug"
                    :title="item.title"
                    :description="item.description"
                    :extract="item.extract"
                    :alcohol="item.alcohol"
                    :ingredients="item.ingredients"
                    :gentian="item.gentian"
                    :color="item.color"
                    :serve="item.serve"
                    :temperature="item.temperature"
                    :image="item.image"
                    :url="item.url"
                    :url_label="item.url_label">
            </item-brand-beer>
        </div>

    </div>
</template>

<script>
    import api from '@/services/Api';

    import PageTitle from '@/components/PageTitle.vue';
    import ItemBrandBeer from '@/items/ItemBrandBeer';

    export default {
        name: 'BrandsIndex',
        components: {PageTitle, ItemBrandBeer},
        data(){
            return {
                brands: [],
                beers: []
            }
        },
        mounted(){
            this.getBrands();
        },
        methods: {
            // todo refactor to vuex
            getBrands(){
                let url = 'knowledges/brands?per_page=100';
                api({url: url, method: 'GET'})
                    .then(resp => {
                        this.brands = resp.data.data;
                        let slug = this.$route.params.slug;
                        console.log(slug)
                        let obj = this.brands.filter((item) => {
                            return item.title === slug; // todo potential error
                        });
                        // append beer list
                        if(obj.length > 0){
                            this.beers = obj[0].list
                        }
                    })
            }
        }
    }
</script>